/* Liquid Ice — clone behaviour (Jarvis 09.10.2026). Vanilla, no dependencies.
   Header (stuck state, hover menus, mobile menu) · announcement rotation · Ajax cart + drawer (Section Rendering API)
   · sliders (scroll-snap + dots/progress) · tabs · reveal on scroll. Sections call window.LI.add(variantId, qty). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* announcement */
  const ann = $('[data-li-announce]');
  if (ann) {
    const items = $$('.li-announce__item', ann); let i = 0, t;
    const show = n => { i = (n + items.length) % items.length; items.forEach((el, k) => el.classList.toggle('is-active', k === i)); };
    const auto = () => { clearInterval(t); if (!matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(() => show(i + 1), 5000); };
    $('[data-prev]', ann)?.addEventListener('click', () => { show(i - 1); auto(); });
    $('[data-next]', ann)?.addEventListener('click', () => { show(i + 1); auto(); });
    auto();
  }

  /* header */
  const header = $('[data-li-header]');
  const mobile = $('[data-li-mobile]');
  if (header) {
    const onScroll = () => header.classList.toggle('-stuck', window.scrollY > 40);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
    const btns = $$('[data-li-menu-btn]', header);
    const closeAll = () => btns.forEach(b => { b.setAttribute('aria-expanded', 'false'); $('#' + b.getAttribute('aria-controls'))?.classList.remove('is-open'); });
    const open = b => { closeAll(); b.setAttribute('aria-expanded', 'true'); $('#' + b.getAttribute('aria-controls'))?.classList.add('is-open'); };
    let leaveT;
    btns.forEach(b => {
      b.addEventListener('click', () => b.getAttribute('aria-expanded') === 'true' ? closeAll() : open(b));
      b.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(leaveT); open(b); } });
    });
    header.addEventListener('mouseleave', () => { leaveT = setTimeout(closeAll, 250); });
    header.addEventListener('mouseenter', () => clearTimeout(leaveT));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', e => { if (!header.contains(e.target)) closeAll(); });
    const burger = $('[data-li-burger]', header);
    burger?.addEventListener('click', () => {
      const on = !header.classList.contains('-mobile-open');
      header.classList.toggle('-mobile-open', on); mobile?.classList.toggle('is-open', on);
      burger.setAttribute('aria-expanded', String(on));
      if (mobile) mobile.style.top = header.getBoundingClientRect().bottom + 'px';
      document.documentElement.style.overflow = on ? 'hidden' : '';
    });
  }

  /* cart */
  const drawerSel = '[data-li-drawer]';
  const setCount = n => $$('[data-li-cart-count]').forEach(el => (el.textContent = n));
  const openCart = () => { const d = $(drawerSel); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; };
  const closeCart = () => { const d = $(drawerSel); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
  const refresh = async (keepOpen = true) => {
    const r = await fetch(`${root}?sections=li-cart-drawer`, { headers: { Accept: 'application/json' } });
    const j = await r.json(); const html = j['li-cart-drawer']; if (!html) return;
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const fresh = $(drawerSel, tmp); const cur = $(drawerSel);
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; if (keepOpen) openCart(); }
    const c = await (await fetch(`${root}cart.js`)).json(); setCount(c.item_count);
  };
  const add = async (id, quantity = 1, btn) => {
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || e.message || 'Fehler'); return; }
      await refresh(true);
    } finally { if (btn) btn.removeAttribute('aria-busy'); }
  };
  const change = async (key, quantity) => {
    await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(quantity) }) });
    await refresh(true);
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-li-add]'); if (a) { e.preventDefault(); add(a.dataset.liAdd, a.dataset.qty || 1, a); return; }
    const q = e.target.closest('[data-li-qty]'); if (q) { e.preventDefault(); change(q.dataset.liQty, q.dataset.q); return; }
    if (e.target.closest('[data-li-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-li-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-li-product-form]'); if (!f) return;
    e.preventDefault(); const fd = new FormData(f);
    add(fd.get('id'), fd.get('quantity') || 1, $('[type=submit]', f));
  });
  window.LI = { add, openCart, closeCart, refresh };

  /* sliders: [data-li-slider] > [data-li-track]; optional [data-li-dots] (buttons), [data-li-progress] > span, [data-li-prev]/[data-li-next] */
  $$('[data-li-slider]').forEach(sl => {
    const track = $('[data-li-track]', sl); if (!track) return;
    const slides = [...track.children]; const dots = $$('[data-li-dots] button', sl); const prog = $('[data-li-progress] span', sl);
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
    const idx = () => Math.round(track.scrollLeft / Math.max(1, step()));
    const sync = () => {
      const i = idx(); dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      if (prog) { const max = track.scrollWidth - track.clientWidth; const w = track.clientWidth / track.scrollWidth; prog.style.width = (w * 100) + '%'; prog.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 / w) - 1) * 100 : 0}%)`; }
      sl.dispatchEvent(new CustomEvent('li:slide', { detail: i }));
    };
    const go = i => track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: 'smooth' });
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    $('[data-li-prev]', sl)?.addEventListener('click', () => go(idx() - 1));
    $('[data-li-next]', sl)?.addEventListener('click', () => go(idx() + 1));
    sl.liGo = go; sync();
    if (sl.hasAttribute('data-li-autoplay') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let t = setInterval(() => go((idx() + 1) % slides.length), Number(sl.dataset.liAutoplay) || 6000);
      sl.addEventListener('pointerdown', () => clearInterval(t), { once: true });
    }
  });

  /* tabs: [data-li-tabs] with [data-tab="n"] buttons and [data-panel="n"] panels */
  $$('[data-li-tabs]').forEach(tb => {
    const btns = $$('[data-tab]', tb), panels = $$('[data-panel]', tb);
    const show = n => { btns.forEach(b => b.classList.toggle('is-active', b.dataset.tab === n)); panels.forEach(p => p.hidden = p.dataset.panel !== n); tb.dispatchEvent(new CustomEvent('li:tab', { detail: n })); };
    btns.forEach(b => b.addEventListener('click', () => show(b.dataset.tab)));
  });

  /* reveal */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -10% 0px' }) : null;
  $$('.li-reveal').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
})();
